import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';


import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import About from './pages/About';
import Uniforms from './pages/Uniforms';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import AppFooter from './components/Footer';
import Home from './pages/Home';
import Politika from './pages/Politika';
import Loader from './components/Loader';
import ScrollUp from './components/ScrollUp';
import CookiesModal from './components/Cookies';


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const time = setTimeout(() => {
      setLoading(false)
    }, 2000) 

    return () => clearTimeout(time)
  },[])
  return (
    <>
    <Router>
      <div className="App">
        <Navbar />

        {loading ? (<Loader/>) : (
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/o-nama" element={<About/>} />
          <Route path="/uniforme" element={<Uniforms/>} />
          <Route path="/galerija" element={<Gallery/>} />
          <Route path="/kontakt" element={<Contact/>} />
          <Route path="/politika-privatnosti" element={<Politika/>} />
        </Routes>
        )}

      
      </div>
      <ScrollUp/>
      <CookiesModal/>
      <AppFooter/>
      
    </Router>
    </>);
}

export default App;
